/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from "@compiled/react";

import { Box, xcss } from "@atlaskit/primitives";
import { N800 } from "@atlaskit/theme/colors";
import { token } from "@atlaskit/tokens";

const errorPageStyles = css({
    height: "80vh",
    justifyContent: "center",
    alignItems: "center",
    display: "flex"
});

const errorContentStyles = xcss({
    alignItems: "center",
    display: "flex",
    flexDirection: "column"
});

const imageStyles = css({
    "backgroundSize": "contain",
    "backgroundRepeat": "no-repeat",
    "height": "218px",
    "width": "163.3px",
    // TODO: Use new breakpoints, info at https://staging.atlassian.design/components/primitives/responsive/breakpoints/examples

    "@media (max-width: 664px)": {
        height: "128.16px",
        width: "96px"
    }
});

const headingStyles = css({
    "color": token("color.background.neutral.bold.pressed", N800),
    "fontFamily": token("font.family.brand.heading"),
    "fontWeight": token("font.weight.medium"),
    "fontSize": "24px",
    "lineHeight": "32px",
    // TODO: Use new breakpoints, info at https://staging.atlassian.design/components/primitives/responsive/breakpoints/examples

    "@media (max-width: 664px)": {
        fontSize: "20px",
        lineHeight: "24px",
        marginBlockStart: token("space.300", "24px")
    }
});

const descriptionStyles = css({
    "fontFamily": token("font.family.brand.body"),
    "fontWeight": token("font.weight.regular"),
    "fontSize": "16px",
    "lineHeight": "24px",
    "marginBlockStart": token("space.200", "16px"),
    // TODO: Use new breakpoints, info at https://staging.atlassian.design/components/primitives/responsive/breakpoints/examples

    "@media (max-width: 664px)": {
        fontSize: "16px",
        lineHeight: "24px",
        marginBlockStart: token("space.300", "24px")
    }
});

const linkStyles = css({
    "textDecoration": "none",
    "&:hover": {
        textDecoration: "underline"
    }
});

interface ErrorHeroProps {
    readonly errorImage: string;
}

export const ErrorHero = ({ errorImage }: ErrorHeroProps) => {
    return (
        <div css={errorPageStyles}>
            <Box xcss={errorContentStyles}>
                <div
                    css={imageStyles}
                    style={{ backgroundImage: `url("${errorImage}")` }}
                />
                <h1 css={headingStyles}>Something went wrong</h1>
                <h2 css={descriptionStyles}>
                    If this keeps happening,{" "}
                    <a
                        css={linkStyles}
                        href="https://support.atlassian.com/contact/"
                    >
                        contact support
                    </a>
                    .
                </h2>
            </Box>
        </div>
    );
};
